var Industry = "Secteur d'activité";
var Aerospace = "Aérospatiale";
var Agriculture = "Agriculture";
var Automotive = "Automobile";
var Education = "Éducation";
var Gaming = "Jeux";
var Government = "Administration publique";
var Healthcare = "Santé";
var Hospitality = "Hôtellerie";
var Manufacturing = "Industrie manufacturière";
var Mining = "Exploitation minière";
var Other = "Autre";
var Retail = "Vente au détail";
var Telecommunications = "Télécommunications";
var Travel = "Voyages";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Informatique et électronique",
	"Consumer goods": "Produits de consommation",
	Education: Education,
	"Financial services": "Services financiers",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Sciences de la vie",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Marketing et publicité",
	"Media & entertainment": "Multimédia et divertissement",
	Mining: Mining,
	"Non-profit organization": "Organisation à but non lucratif",
	"Oil & gas": "Pétrole et gaz",
	Other: Other,
	"Power & utilities": "Énergie, eau, gaz et électricité",
	"Professional services": "Services professionnels",
	"Real estate & construction": "Immobilier et construction",
	Retail: Retail,
	"Software & internet": "Logiciels et Internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Transports et logistique",
	Travel: Travel,
	"Wholesale & distribution": "Commerce de gros et distribution"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
